<template>
  <div
    class="z-code-editor"
    :style="{ height: height }"
  >
    <pre
      ref="highlight"
      class="z-code-editor__highlight"
      aria-hidden="true"
    ><code
      class="language-markup"
      v-html="highlighted"
    /></pre>
    <textarea
      ref="textarea"
      v-model="val"
      class="z-code-editor__input"
      spellcheck="false"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      dir="ltr"
      wrap="off"
      @scroll="syncScroll"
    />
  </div>
</template>

<script>
import Prism from 'prismjs'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-css'
import 'prismjs/themes/prism-okaidia.css'

export default {
  name: 'ZCodeEditor',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    height: {
      type: String,
      default: '420px',
    },
  },
  data() {
    return {
      val: this.value,
    }
  },
  computed: {
    highlighted() {
      const code = this.val == null ? '' : String(this.val)
      // یک خط خالی انتهایی تا کرسر آخرین سطر با هایلایت هم‌تراز بماند
      return Prism.highlight(`${code}\n`, Prism.languages.markup, 'markup')
    },
  },
  watch: {
    value(v) {
      if (v !== this.val) {
        this.val = v
      }
    },
    val(v) {
      this.$emit('input', v)
      this.$nextTick(this.syncScroll)
    },
  },
  methods: {
    syncScroll() {
      const ta = this.$refs.textarea
      const hl = this.$refs.highlight
      if (!ta || !hl) {
        return
      }
      hl.scrollTop = ta.scrollTop
      hl.scrollLeft = ta.scrollLeft
    },
  },
}
</script>

<style scoped>
.z-code-editor {
  position: relative;
  width: 100%;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  overflow: hidden;
  background: #272822;
}

.z-code-editor__highlight,
.z-code-editor__input {
  margin: 0;
  padding: 12px 14px;
  border: 0;
  width: 100%;
  height: 100%;
  font-family: 'Fira Code', 'Consolas', 'Courier New', monospace;
  font-size: 13px;
  line-height: 20px;
  tab-size: 2;
  white-space: pre;
  overflow: auto;
  direction: ltr;
  text-align: left;
}

.z-code-editor__highlight {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.z-code-editor__highlight >>> code {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  background: transparent;
  white-space: pre;
}

.z-code-editor__input {
  position: relative;
  z-index: 1;
  background: transparent;
  color: transparent;
  caret-color: #f8f8f2;
  resize: none;
  outline: none;
}

.z-code-editor__input::selection {
  background: rgba(120, 130, 200, 0.45);
}
</style>
